import MarkdownIt from 'markdown-it';

export const markdownStrikethroughPlugin = (md: MarkdownIt): void => {
  md.inline.ruler.after('emphasis', 'strikethrough', (state, silent) => {
    const max = state.posMax;
    const start = state.pos;

    if (state.src.charCodeAt(start) !== 0x7e /* ~ */) return false;
    if (start + 2 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x7e) return false;

    let matchEnd = start + 2;
    while (matchEnd < max) {
      if (state.src.charCodeAt(matchEnd) === 0x7e && state.src.charCodeAt(matchEnd + 1) === 0x7e) {
        break;
      }
      matchEnd++;
    }

    if (matchEnd >= max || matchEnd === start + 2) return false;

    if (!silent) {
      const openToken = state.push('s_open', 's', 1);
      openToken.markup = '~~';
      state.push('text', '', 0).content = state.src.slice(start + 2, matchEnd);
      const closeToken = state.push('s_close', 's', -1);
      closeToken.markup = '~~';
    }

    state.pos = matchEnd + 2;
    return true;
  });
};
